export default __webpack_public_path__ + "static/media/7 - Терминалы для карты «Тройка».805b0e65.jpg";